import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { Observable } from 'rxjs';

import { ViMonitorSetupComponent } from '../components/ViMonitorSetup/vi-monitor-setup.component';
import { ViMonitorService } from '../services/vi-monitor.service';

@Injectable()
export class ViMonitorSetupDeactivateGuard implements CanDeactivate<ViMonitorSetupComponent> {
    constructor(private viMonitorService: ViMonitorService) {}

    canDeactivate(): Observable<boolean> {
        return this.viMonitorService.canDeactivate$();
    }
}
